var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.216 3C8.5713 3 8.8586 3.2635 8.8586 3.5882V4.7765C9.4281 4.7663 10.0673 4.7663 10.7864 4.7663H14.2136C14.9327 4.7663 15.5711 4.7663 16.1414 4.7765V3.5882C16.1414 3.2635 16.4287 3 16.784 3C17.1393 3 17.4266 3.2635 17.4266 3.5882V4.8275C18.6591 4.9176 19.4692 5.1403 20.0641 5.6843C20.6592 6.22915 20.9014 6.97035 21 8.1V8.95H4V8.1C4.0986 6.97035 4.34085 6.23 4.93585 5.6843C5.53085 5.1403 6.34005 4.9176 7.5734 4.8275V3.5882C7.5734 3.2635 7.86155 3 8.216 3Z",
    fill: "#202E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.0001 13.2V11.5C21.0001 10.7868 20.989 9.5152 20.978 8.94995H4.00516C3.99411 9.5152 4.00516 10.7868 4.00516 11.5V13.2C4.00516 16.4053 4.00516 18.0084 4.99966 19.0038C5.99671 20 7.59896 20 10.8035 20H14.2035C17.408 20 19.0094 20 20.0056 19.0038C21.0001 18.0084 21.0001 16.4053 21.0001 13.2Z",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9 12.5625C16.0691 12.5625 16.2312 12.6297 16.3508 12.7492C16.4703 12.8688 16.5375 13.0309 16.5375 13.2V14.2625H17.6C17.7691 14.2625 17.9312 14.3297 18.0508 14.4492C18.1703 14.5688 18.2375 14.7309 18.2375 14.9C18.2375 15.0691 18.1703 15.2312 18.0508 15.3508C17.9312 15.4703 17.7691 15.5375 17.6 15.5375H16.5375V16.6C16.5375 16.7691 16.4703 16.9312 16.3508 17.0508C16.2312 17.1703 16.0691 17.2375 15.9 17.2375C15.7309 17.2375 15.5688 17.1703 15.4492 17.0508C15.3297 16.9312 15.2625 16.7691 15.2625 16.6V15.5375H14.2C14.0309 15.5375 13.8688 15.4703 13.7492 15.3508C13.6297 15.2312 13.5625 15.0691 13.5625 14.9C13.5625 14.7309 13.6297 14.5688 13.7492 14.4492C13.8688 14.3297 14.0309 14.2625 14.2 14.2625H15.2625V13.2C15.2625 13.0309 15.3297 12.8688 15.4492 12.7492C15.5688 12.6297 15.7309 12.5625 15.9 12.5625Z",
    fill: "#202E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a532fb0e1bed1e51dd2a94199b0b83c2.svg";
export { ForwardRef as ReactComponent };